import { dialApiFetch, isDialApiConfigured } from './client';

export interface ScriptResponse {
  contact_type: string;
  body: string | null;
  updated_at: string | null;
  /** C3: which level of the fallback chain provided the body. 'none' when
   * no script is set anywhere. */
  scope?: 'campaign' | 'user' | 'org_default' | 'none';
}

// Fallback used when the worker isn't reachable from the browser (local dev
// without VITE_DIAL_API_URL set, or before the seed migration runs). The
// runner still rotates these by contact type so the demo behaviour is
// realistic without a network round-trip.
const DEMO_SCRIPTS: Record<string, string> = {
  Architect:
    "Hi [contact name], it's [you] from Zanda. Quick reason — Ember Bronze IPL just released and the multi-res guys are picking it up fast. Worth a sample pack?",
  Specifier:
    "Hi [contact name], [you] from Zanda. We've overhauled the AS.1428 commercial range — making sure your spec library's up to date. Two minutes?",
  Builder:
    'Hi [contact name], [you] from Zanda. Quick check-in — Ember Bronze IPL is in stock, multi-res builds are picking it up. Worth a look?',
  Developer:
    'Hi [contact name], [you] from Zanda. Tier-pricing on the multi-res hardware schedule for projects starting this quarter. Two minutes?',
  'Project Manager':
    "Hi [contact name], [you] from Zanda. Couple of new options that'd save lead time on the next spec list. Worth a chat?",
};

const FALLBACK =
  "Hi [contact name], it's [you] from Zanda. Reaching out about our latest commercial range — got two minutes?";

export async function getScript(
  contactType: string,
  campaignId?: string | null,
): Promise<ScriptResponse> {
  if (!isDialApiConfigured) {
    return {
      contact_type: contactType,
      body: DEMO_SCRIPTS[contactType] ?? FALLBACK,
      updated_at: null,
      scope: 'org_default',
    };
  }
  const params = new URLSearchParams({ contactType });
  if (campaignId) params.set('campaignId', campaignId);
  return dialApiFetch<ScriptResponse>(`/v1/scripts?${params.toString()}`);
}
